<ng-container *ngIf="portalOrder$ | async as portalOrder">
  @let buttonText = portalTiers ? 'View booking options' : 'Continue to booking';

  <div class="d-flex flex-column w-100">
    <flight-info
      (back)="back()"
      [showBack]="true"
      [portalOrder]="portalOrder"
      title="Option {{ portalOrder.alphaName }}"
      class="mx-4 mx-md-0 flight-info"
    />

    <hr class="d-md-none mt-4" />

    <referral-credit-banner
      [referralCredit]="portalOrder.referralCredit"
      bookingWindowLabel="3 months"
    />

    <div
      *ngIf="portalOrder.portalDescription"
      class="d-flex align-items-top px-4 px-md-0 mt-4 mt-md-6"
    >
      <img src="/assets/icons/note.svg" alt="note" width="20" height="20" />
      <p data-id="option-description" class="ml-2">{{ portalOrder.portalDescription }}</p>
    </div>

    <div class="d-flex align-items-center mt-6 px-4 px-md-0 scrollable hide-scrollbar">
      @if (portalOrder.expertChoice) {
        <option-full-badge
          type="purple"
          title="Expert's choice"
          description="Recommended by our travel experts for the best experience."
          img="star"
        />
      }
      @if (portalOrder.fastest) {
        <option-full-badge
          type="aqua"
          title="Fastest option"
          description="The quickest route to your <br/> destination."
          img="rocket"
        />
      }
      @if (portalOrder.serviceClass === portalServiceClassType.MIXED) {
        <option-full-badge
          type="gray"
          title="Mixed cabin"
          description="Seats in different cabin classes on <br/> one trip for more flexibility."
          img="cabin"
        />
      }
    </div>

    <div class="d-flex flex-column flex-md-row content">
      <div class="flex-1">
        <portal-option-details
          [itineraries]="portalOrder.flightItineraries"
          [portalLink]="state.portalLink"
          class="option-details"
        />

        <div *ngIf="portalOrder.hotelBookings?.length" class="mt-6 d-flex">
          <hotel-bookings
            [hotelBookings]="portalOrder.hotelBookings"
            class="w-100 hotel-bookings"
          />
        </div>

        <div class="d-flex flex-column flex-md-row">
          <div class="flex-1">
            <div class="d-none d-md-flex mt-8">
              <ds-button
                (click)="back()"
                variant="secondary"
                [fullWidth]="true"
                class="w-md-unset"
                leadingIcon="chevronLeft"
                data-id="back"
                label="Back"
              />

              @if (!hideEmbeddedButtons) {
                <ds-button
                  (click)="requestToBook(portalOrder)"
                  [fullWidth]="true"
                  class="ml-md-auto w-md-unset"
                  id="submit"
                  data-id="submit"
                  trailingIcon="chevronRight"
                  [label]="buttonText"
                />
              }
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column-reverse flex-md-column mt-md-4">
        <div class="price-summary">
          <price-summary
            [option]="portalOrder"
            [disruptionProtection]="state.disruptionProtection"
            [tipsAmount]="state.tipsAmount"
            [cancelForAnyReason]="state.cancelForAnyReason"
            [promocodeDiscountAmount]="state.promocodeDiscountAmount"
            [bundle]="state.bundle"
          />
        </div>

        <div class="d-flex flex-column mt-4 mx-4 mt-md-4 mx-md-0 mb-4 mb-md-0">
          @if (!portalOrder.isChange) {
            <risk-free-badge class="mb-4" />
          }
          <trustpilot-badge />
        </div>
      </div>

      <div class="d-flex flex-column flex-md-row d-md-none mx-4">
        <div class="d-flex flex-column">
          @if (!hideEmbeddedButtons) {
            <ds-button
              (click)="requestToBook(portalOrder)"
              [fullWidth]="true"
              class="w-md-unset"
              id="submit"
              data-id="submit"
              trailingIcon="chevronRight"
              [label]="buttonText"
            />
          }

          <ds-button
            (click)="back()"
            variant="secondary"
            leadingIcon="chevronLeft"
            [fullWidth]="true"
            class="mt-4 w-md-unset"
            data-id="back"
            label="Back"
          />
        </div>
      </div>
    </div>

    <need-help-card
      [salesAgent]="(portalLeadService.portalLead$ | async)?.salesAgent"
      class="mb-5 mr-md-0 ml-md-0 mr-4 ml-4"
    />
  </div>
</ng-container>

<ng-template #hiddenFlightsTemplate>
  <hidden-flights-modal
    (hiddenFlightsPresented)="refetchLead()"
    (requestToBook)="requestToBook($event); hideModal()"
    (hideModal)="hideModal()"
    [option]="portalOrder"
  />
</ng-template>

<ng-template #askToSignInTemplate>
  <ask-to-sign-in-modal
    (hideModal)="hideAskToSignInModal()"
    (continueAsGuest)="continueAsGuestFromSignInPrompt()"
    (showSignInModal)="showSignInModal()"
  />
</ng-template>
